import Api from './api.service';

const ENDPOINT = 'health-plans';

export default {
  update: (id, data) => Api.put(`${ENDPOINT}/${id}`, data),
  destroy: (id) => Api.delete(`${ENDPOINT}/${id}`),
  store: (data) => Api.post(`${ENDPOINT}`, data),
  get: (params = {}) =>
    Api.get(`${ENDPOINT}`, {
      params,
    }),
  getId: (id, params = {}) =>
    Api.get(`${ENDPOINT}/${id}`, {
      params,
    }),
  setProcedures: (healthPlanId, data = {}) =>
    Api.patch(`${ENDPOINT}/${healthPlanId}/procedures`, data),
  getHealthPlanSchedules: (params = {}) =>
    Api.get(`schedules/health-plan-schedules`, {
      params,
    }),
};
